import { ProductSelectorProps } from "./product-selector.types";
import { ProductSelectorSkin1 } from "./skins/product-selector-skin-1";

export const ProductSelector = (props: ProductSelectorProps) => {
  return <ProductSelectorSkin1 {...props} />;
};
